import React from 'react';
import { trackAddToCart } from '../utils/pixel';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
import { ShieldCheck, Download } from 'lucide-react';
export function PricingCTA() {
  return <section id="pricing" className="py-16 md:py-32 relative overflow-hidden" data-id="element-204">
      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-burgundy/10 to-deep-black" data-id="element-205"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-champagne-gold/5 rounded-full blur-[100px] pointer-events-none" data-id="element-206"></div>

      <div className="max-w-4xl mx-auto px-6 relative z-10 text-center" data-id="element-207">
        <FadeIn data-id="element-208">
          <div className="inline-block mb-8 px-6 py-2 rounded-full border border-champagne-gold/50 bg-champagne-gold/10 backdrop-blur-sm" data-id="element-209">
            <span className="text-champagne-gold font-semibold tracking-widest uppercase text-sm" data-id="element-210">
              Accès Immédiat
            </span>
          </div>
        </FadeIn>

        {/* Ebook Covers Showcase */}
        <FadeIn delay={0.15} data-id="element-211">
          <div className="flex items-end justify-center gap-4 md:gap-8 mb-16" data-id="element-212">
            <motion.img whileHover={{
            scale: 1.05,
            rotate: -1
          }} src="https://cdn.magicpatterns.com/uploads/gAdVafEEb7rYzEbUhvTirs/COVER_BONUS_1.png" alt="Le Lexique Secret" className="w-24 md:w-36 rounded-xl shadow-lg shadow-burgundy/30 border border-champagne-gold/10 -rotate-6" data-id="element-213" />
            <motion.img whileHover={{
            scale: 1.05
          }} src="https://cdn.magicpatterns.com/uploads/daztqiWmen7ceve4wfF7Ps/COVER.png" alt="L'Algorithme de l'Amour" className="w-36 md:w-52 rounded-xl shadow-2xl shadow-champagne-gold/20 border border-champagne-gold/20 relative z-10" data-id="element-214" />
            <motion.img whileHover={{
            scale: 1.05,
            rotate: 1
          }} src="https://cdn.magicpatterns.com/uploads/nUKpe8GUUrRK5DwPfik4Wk/COVER_BONUS_2.png" alt="Le Détecteur de Cons" className="w-24 md:w-36 rounded-xl shadow-lg shadow-burgundy/30 border border-champagne-gold/10 rotate-6" data-id="element-215" />
          </div>
        </FadeIn>

        {/* Gold divider */}
        <div className="w-24 h-px bg-champagne-gold/40 mx-auto mb-12" data-id="element-216"></div>

        <FadeIn delay={0.2} data-id="element-217">
          <div className="flex flex-col items-center justify-center gap-4 mb-12" data-id="element-218">
            <p className="text-muted-cream text-lg line-through decoration-burgundy decoration-2" data-id="element-219">
              VALEUR TOTALE DU PACK : 101$
            </p>
            <div className="flex items-center gap-4" data-id="element-220">
              <span className="text-2xl text-champagne-gold font-playfair italic" data-id="element-221">
                Prix de lancement
              </span>
              <span className="text-6xl md:text-7xl font-playfair font-bold text-cream gold-shimmer" data-id="element-222">
                9,97$
              </span>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-223">
          <motion.a href="https://redevenirmoi.com/cart/53549720371568:1" target="_blank" rel="noopener noreferrer" onClick={() => {
          trackAddToCart({
            content_name: "L'Algorithme de l'Amour - L'Effet Obsession",
            content_type: 'product',
            value: 9.97,
            currency: 'USD'
          });
        }} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="group relative w-full sm:w-auto inline-flex flex-col items-center justify-center px-8 py-6 sm:px-16 sm:py-8 bg-champagne-gold rounded-full shadow-gold-glow-lg hover:shadow-[0_0_60px_rgba(212,175,55,0.6)] transition-all duration-300 no-underline cursor-pointer" data-id="element-224">
            <span className="text-deep-black font-bold text-lg sm:text-2xl uppercase tracking-widest mb-1" data-id="element-225">
              OUI, JE VEUX L'EFFET OBSESSION
            </span>
            <span className="text-deep-black/80 font-medium text-xs sm:text-sm tracking-wider" data-id="element-226">
              — ACCÈS INSTANTANÉ —
            </span>
            <div className="absolute inset-0 rounded-full bg-white/20 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-227"></div>
          </motion.a>
        </FadeIn>

        <FadeIn delay={0.6} data-id="element-228">
          <div className="mt-8 flex flex-col items-center gap-4" data-id="element-229">
            <div className="flex items-center gap-2 text-muted-cream text-sm font-light" data-id="element-230">
              <Download size={16} className="text-champagne-gold" data-id="element-231" />
              Téléchargement immédiat en PDF — Lisible sur Smartphone, Tablette
              et PC
            </div>
            <div className="flex items-center gap-2 text-champagne-gold text-sm font-medium bg-champagne-gold/10 px-4 py-2 rounded-full border border-champagne-gold/20" data-id="element-232">
              <ShieldCheck size={18} data-id="element-233" />
              Satisfaite ou remboursée — Garantie 30 jours, sans question.
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}